export default __webpack_public_path__ + "static/background-day-76862f9964071774309bc55e5b67b587.png";